
import BaseButton from "@/components/base/BaseButton.vue";
import BaseExpansion from "@/components/base/BaseExpansion.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import BookingBasket from "@/components/booking/basket/BookingBasket.vue";
import useBookingNavigation from "@/composables/useBookingNavigation";
import { useBookingSummaryStore } from "@/store/basket";
import { computed, defineComponent, ref } from "vue";
import BookingHeader from "../../BookingHeader.vue";

export default defineComponent({
	components: {
		BaseExpansion,
		BookingBasket,
		BaseSvg,
		BaseButton,
		BaseSection,
		BookingHeader,
	},
	setup() {
		const showBasket = ref(true);
		const loading = ref(false);
		const { nextStep, prevStep, loadingNextStep } = useBookingNavigation();
		const bookingSummaryStore = useBookingSummaryStore();
		const toggleBasket = () => {
			showBasket.value = !showBasket.value;
		};

		const bookingSummary = computed(() => {
			return bookingSummaryStore.getBookingSummary;
		});

		return {
			toggleBasket,
			showBasket,
			loading,
			nextStep,
			prevStep,
			bookingSummary,
            loadingNextStep
		};
	},
});
